/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Contract_Service_Fee_RequiredInputs */

const en_clients_validation_contract_service_fee_required = /** @type {(inputs: Clients_Validation_Contract_Service_Fee_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fee is required.`)
};

const pt_br2_clients_validation_contract_service_fee_required = /** @type {(inputs: Clients_Validation_Contract_Service_Fee_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A taxa é obrigatória.`)
};

/**
* | output |
* | --- |
* | "Fee is required." |
*
* @param {Clients_Validation_Contract_Service_Fee_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_contract_service_fee_required = /** @type {((inputs?: Clients_Validation_Contract_Service_Fee_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Contract_Service_Fee_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_contract_service_fee_required(inputs)
	return pt_br2_clients_validation_contract_service_fee_required(inputs)
});